import { ChangeDetectionStrategy, Component, DestroyRef, input, OnDestroy } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { AsyncPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Observable, switchMap } from 'rxjs';
import { BomItemOrdersState, BomItemOrdersStore } from './bom-item-orders.store';
import { ORDER_STATUS_LABELS } from '../../../orders-new/models/order.dto';
import { formatNumber } from '../../../../../utils/format-amount';

@Component({
  selector: 'bom-item-orders',
  templateUrl: './bom-item-orders.component.html',
  styleUrl: './bom-item-orders.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, RouterLink]
})
// The card follows the bomItemId input: every change re-inits the store (switchMap drops stale in-flight responses)
export class BomItemOrdersComponent implements OnDestroy {
  readonly bomItemId = input.required<number | undefined>();

  readonly statusLabels = ORDER_STATUS_LABELS;

  formatNumber = formatNumber;

  readonly state$: Observable<BomItemOrdersState>;

  constructor(
    private store: BomItemOrdersStore,
    private destroyRef: DestroyRef
  ) {
    this.state$ = this.store.state$;

    toObservable(this.bomItemId)
      .pipe(
        switchMap(bomItemId => this.store.init(bomItemId)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.store.destroy();
  }
}
